import { doGet, doPost } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL, GROLOG_URL_DEV } from "../../../constant/apiConstant";
import { setTableLoading } from "../../../store/reducer/page.reducer";
import { checkValidationToken } from "../../../util/errorHandler";

export const getListTemperatureCategory = async (token, refresh_token, param, dispatch) => {
  const url = `${GROLOG_URL_DEV}/temperature-category?page=1&limit=10`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}

export const getDetail = async (token, refresh_token, id, dispatch) => {
  const url = `${GROLOG_URL}/temperature-category/${id}`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const insertData = async (token, data, params, dispatch) => {
  const url = `${GROLOG_URL}/temperature-category`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
    const response = await doPost(url, token, data, params);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, null, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const getList = async (token, page, limit, order, filter) => {
  const url = `${GROLOG_URL}/temperature-category`;
  let params = { page, limit, order, filter }
  let result = { list: undefined, ok: false };

  try {
    const res = await doGet(token, url, params);

    if (res?.data?.success) {
      result.ok = true;
      result.list = res?.data?.payload?.data;
    }
  } catch (error) {
    return error
  }

  return result;
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
  const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq temperature_category, primary_key eq ${id}`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}